import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  get_job_details_hiring_manager_action,
  get_all_mentors_applied_hiring_manager_action,
} from "../../../redux/_actions";

function useMentorsApplied() {
  const [loading, setLoading] = useState(false);
  const [allMentorsApplied, setAllMentorsApplied] = useState();
  const [jobDetails, setJobDetails] = useState({});
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { allMentorsAppliedData } = useSelector(
    (state) => state.get_all_mentors_applied_hiring_manager_reducer
  );

  const { jobDetailsData } = useSelector(
    (state) => state.get_job_details_hiring_manager_reducer
  );

  useEffect(() => {
    let jobId = location.state;

    if (jobId) {
      callJobDetailsApi(jobId);
      callMentorsAppliedApi(jobId);
    }
  }, []);

  useEffect(() => {
    if (allMentorsAppliedData?.data) {
      setAllMentorsApplied(allMentorsAppliedData.data.results);
    }
  }, [allMentorsAppliedData]);

  //set filtered data
  useEffect(() => {
    if (jobDetailsData?.data) setJobDetails(jobDetailsData?.data);
  }, [jobDetailsData]);

  const callJobDetailsApi = async (id) => {
    setLoading(true);
    await dispatch(get_job_details_hiring_manager_action(id));
    setLoading(false);
  };

  const callMentorsAppliedApi = async (id) => {
    setLoading(true);
    await dispatch(get_all_mentors_applied_hiring_manager_action(id));
    setLoading(false);
  };

  const onMentorOpenNotificationClick = async (id) => {
    navigate(
      `/mentor-applied-notification-accept?job=${jobDetails?.id}&applicant=${id}`
    );
  };

  const onViewMentorProfileClick = async (id, jobTitle) => {
    navigate(`/view-mentor-profile/${id}`, {
      state: {
        id: id,
        jobTitle: jobTitle,
      }
    });
  };

  const onBackClick = () => {
    navigate(-1);
  };

  return {
    loading,
    allMentorsApplied,
    jobDetails,
    onMentorOpenNotificationClick,
    onViewMentorProfileClick,
    onBackClick,
  };
}

export default useMentorsApplied;
